module.exports = __webpack_public_path__ + "static/media/stop-the-cavity-monster_how-do-we.3e7a1af.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/stop-the-cavity-monster_how-do-we.mp3
// module id = tl5U
// module chunks = 0